import PropTypes from "prop-types"

import withMatchingProducts from "areas/product/hoc/with-matching-products"
import { cn } from "styles/utils"

import { Section } from "./components"
import ProductsList from "./products-list"

const RecommendTitle = ({ className, ...props }) => (
  <h3
    className={cn(
      "text-20 leading-28 desktop:mb-10 desktop:mt-0 desktop:text-left mt-24 text-center font-medium",
      className
    )}
    {...props}
  />
)

const ProductRecommendations = ({ pairsWell, recommended }) => {
  if (pairsWell.length + recommended.length === 0) return null

  return (
    <Section className="desktop:pt-24" data-cy="product-recommendations">
      <div className="desktop:flex-row desktop:mx-0 desktop:px-32 desktop:py-10 border-grey-10 mx-16 flex flex-col border-y">
        {pairsWell.length > 0 && (
          <div
            className={cn(
              "w-full",
              recommended.length > 0 &&
                "desktop:max-w-1/2 desktop:min-w-160 desktop:pr-10 desktop:overflow-x-auto desktop:w-auto desktop:border-r desktop:border-b-0 border-grey-10 border-b"
            )}
          >
            <RecommendTitle key="matching-title">
              PAIRS WELL WITH
            </RecommendTitle>
            <div className="desktop:mr-0 -mr-16">
              <ProductsList
                displayArrows={{
                  _: "none",
                  desktop: pairsWell.length > 3 ? "flex" : "none",
                  tablet: pairsWell.length > 2 ? "flex" : "none",
                }}
                key="matching-list"
                linkClickData="pairs-well-with-product-list"
                name="Pairs well with"
                products={pairsWell}
              />
            </div>
          </div>
        )}
        {recommended.length > 0 && (
          <div
            className={cn(
              "w-full flex-1",
              pairsWell.length > 0 &&
                "desktop:overflow-x-auto desktop:pl-10 desktop:w-auto"
            )}
          >
            <RecommendTitle key="matching-title">
              YOU MAY ALSO LIKE
            </RecommendTitle>
            <div className="desktop:mr-0 -mr-16">
              <ProductsList
                displayArrows={{
                  _: "none",
                  desktop: recommended.length > 3 ? "flex" : "none",
                  tablet: recommended.length > 2 ? "flex" : "none",
                }}
                key="matching-list"
                linkClickData="ymal-product-list"
                name="You may also like"
                products={recommended}
              />
            </div>
          </div>
        )}
      </div>
    </Section>
  )
}

ProductRecommendations.propTypes = {
  pairsWell: PropTypes.array.isRequired,
  recommended: PropTypes.array.isRequired,
}
RecommendTitle.propTypes = {
  className: PropTypes.string,
}
export default withMatchingProducts(ProductRecommendations)
